export default [
    {
        path: '/rest/proptemplate/:id/:type',
        name: 'legacy.proptemplate.save'
    },
    {
        path: '/rest/propdocument/:id/:type',
        name: 'legacy.propdocument.save'
    }
]